/**
Configuration (in db) must follow example (if default missing, first item of languages will be considered as the default language) =>
{
	"app": "ADMIN_PORTAL",
	"type": "ui",
	"configurations": [{
        "name": "NOT_USED",
        "key": "NOT_USED",
        "type": "language",
        "data": {
            "default": "en",
            "languages": [
                {"code": "en"}, 
                {"code": "ja"}, 
                {"code": "vi"},
                {"code": "he", "rtl": true},
            ]
        }
    }]
}
 */

import _ from 'lodash'
import { constants } from '../../constants'

import retrieveLanguage from './retrieveLanguage'

const frontDefaultLanguage = 'en'
const stringsData = {}
const emptyHandler = {
    get: function (target, name) {
        return target.hasOwnProperty(name) ? target[name] : `{${name}}`
    },
}
export const strings = new Proxy(_.clone(stringsData), emptyHandler)

export let languages = [frontDefaultLanguage]
export let language = frontDefaultLanguage
export let rtl = false
let defaultLanguage = frontDefaultLanguage

export async function setAvailableLanguages(newLanguages) {
    const tmpDefaultLanguage = newLanguages.default
    const tmpLanguages = newLanguages.languages

    if (tmpDefaultLanguage && tmpLanguages.some(lang => lang.code === tmpDefaultLanguage))
        defaultLanguage = tmpDefaultLanguage
    else defaultLanguage = tmpLanguages[0].code

    languages = tmpLanguages
}

export async function loadLanguage({ queryLanguage, localStorageLanguage, forcedLanguage }) {
    let newLanguage =
        forcedLanguage ||
        queryLanguage ||
        localStorageLanguage ||
        defaultLanguage
    const { isLanguageChangeEnabled } = constants.configFeatureFlags

    if(isLanguageChangeEnabled === 'false'){
        newLanguage = defaultLanguage
    }
    
    if (typeof newLanguage === 'string') newLanguage = newLanguage.toLowerCase()

    const content = await retrieveLanguage({
        component: 'delivery',
        app: 'admin-portal',
        platform: 'web',
        language: newLanguage,
    })

    Object.assign(strings, content)

    language = newLanguage
    rtl = languages.find(l => l.code === newLanguage)?.rtl || false

    return newLanguage
}

/**
 * E.g.
 *      string = "WELCOME" &&
 *      replacements = { name: "Seba" } &&
 *      strings = { WELCOME: "Welcome {name} to 711" }
 *      => "Welcome Seba to 711"
 * E.g.2
 *      string = "WELCOME" &&
 *      replacements = {notName: "Seba"} &&
 *      strings = { WELCOME: "Welcome {name} to 711", name: "Juan" }
 *      => "Welcome Juan to 711"
 * E.g.3
 *      string = "WELCOME" &&
 *      replacements = {name: "Seba"} &&
 *      strings = { WELCOME: "Welcome {name} to 711", name: "Juan" }
 *      => "Welcome Seba to 711"
 * E.g.4
 *      string = "WELCOME" &&
 *      replacements = {name} &&
 *      strings = { NOT_WELCOME: "Welcome {name} to 711" }
 *      => "{NOT_WELCOME}"
 * @param {String} string
 * @param {_:String} replacements
 * @returns {String}
 */
export function formatString(string, replacements = {}) {
    let finalString = ''
    let replacement = ''

    const stringTemplate = strings[string]

    for (let i = 0; i < stringTemplate.length; i++) {
        const character = stringTemplate[i]
        if (character === '}') {
            if (replacement.length > 1) {
                // TODO: Missing Easy Format Currency, Numbers and Dates
                const variable = replacement.substring(1)
                let value = replacements[variable]
                if (value === undefined) value = strings[variable]
                finalString += value
                replacement = ''
                continue
            }
        }

        if (i + 1 === stringTemplate.length) {
            finalString += replacement + character
            continue
        }

        if (character === '{') {
            finalString += replacement
            replacement = character
            continue
        }

        if (replacement.length) {
            replacement += character
            continue
        }

        finalString += character
    }

    return finalString
}

export function formatStringGroupAsArray(string, varieties) {
    const array = []

    for (const variety of varieties) {
        let realString = string
        for (const property in variety) {
            realString = realString.replace(`{${property}}`, variety[property])
        }
        array.push(strings[realString])
    }

    return array
}
